const CONST = {
  SCENE:{
    FLOOR1: "floor1",
    FLOOR2: "floor2",
    EXTERIOR: "exterior",
    TEST2_FLOOR1: "test2_floor1",
    TEST2_FLOOR2: "test2_floor2",
    TEST2_EXTERIOR: "test2_exterior"
  },
  MATERIAL:{
    RED: "red",
    GREEN: "green",
    BLUE: "blue"
  }
}

export default CONST;
